module.exports = __webpack_public_path__ + "img/Sudoeste.bd8a785b.svg";